// extracted by mini-css-extract-plugin
export default {"pageFilterWrapper":"productSetFilters_pageFilterWrapper__6UDPq"};